import { useLayoutEffect, useRef, useState } from 'react';
import { cn } from '@shared/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface TruncatedAmountProps {
  value: string;
  className?: string;
}

export function TruncatedAmount({ value, className }: TruncatedAmountProps) {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const check = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [value]);

  const textClassName = cn('block min-w-0 truncate tabular-nums', className);

  if (!isTruncated) {
    return (
      <span ref={textRef} className={textClassName}>
        {value}
      </span>
    );
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={textClassName}>{value}</span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs tabular-nums">{value}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
